
export function getServerBasePath() {
    if(window.location.host === 'romi-system.co.il') {
        return 'https://api.romi-system.co.il'
    }
    else if(window.location.host === 'www.romi-system.co.il') {
        return 'https://api.romi-system.co.il'
    }
    else if(window.location.host === 'romi-system.smartbid.tech') {
        return 'https://romi-system-api.smartbid.tech';
    }
    //return 'https://api.romi-system.co.il';

    return 'http://romi-system.dart-dima.localhost:9001';
    ////return 'http://romi-system.localhost:9000';
}


export const ListUserTypes =
    [
        {id:-1, name: ""},
        {id: 1, name: "Store"},
        {id: 2, name: "ManagerCellular"},
        {id: 3, name: "Admin"},
        {id: 4, name: "ManagerTVOrInternet"},
        {id: 5, name: "ManagerCellular012"},
        {id: 6, name: "ManagerAllTypes"}
    ];

export const ListUserNameHe =
    [
        {id:-1, name: ""},
        {id: 1, name: "חנות"},
        {id: 2, name: "סלולר"},
        {id: 3, name: "אדמין"},
        {id: 4, name: "אינטרנט\\טלויזיה"},
        {id: 5, name: "סלולר012"},
        {id: 6, name: "הכל"}
    ];

export const DealsTypesHe =
    [
        {id:-1, name: ""},
        {id: 1, name: "חדש"},
        {id: 2, name: "פעיל"},
        {id: 3, name: "לא פעיל"},
        {id: 4, name: "בוצע חלקית"},
        {id: 5, name: "אין מענה"},
        {id: 6, name: "לא תקין"},
        {id: 7, name: "בוטל"},
        {id: 8, name: "הוקם"},
        {id: 9, name: "המשך טיפול"}
    ];

export const ListUserTypesEnum = {};

for (var currUserTypeIndex in ListUserTypes){
    ListUserTypesEnum[ListUserTypes[currUserTypeIndex].name] = ListUserTypes[currUserTypeIndex].id;
}
